import { Stack } from '@mui/material';
import { FieldRowLabel } from '@Components/shared/labels/FieldRowLabel';
import { useMinesRoundDrawer } from '@Modal/hooks/rounds/useMinesRoundDrawer';
import styles from './SetupMinesRoundDrawerDetails.module.scss';

export const SetupMinesRoundDrawerDetails = () => {
  const { selectedRoundData } = useMinesRoundDrawer();
  const { betAmount, gridSize, minesCount, autoplay, autobetConfig, revealedTiles } =
    selectedRoundData;

  return (
    <Stack
      direction="column"
      spacing={1}
      padding="24px"
      className={styles.SetupMinesRoundDrawerDetails}
    >
      <FieldRowLabel label="Bet Amount" value={betAmount ? betAmount : 'No Result'} />
      <FieldRowLabel label="Grid Size" value={gridSize ? gridSize : 'No Result'} />
      <FieldRowLabel label="Mines Count" value={minesCount ? minesCount : 'No Result'} />
      <FieldRowLabel label="Autoplay" value={autoplay ? 'True' : 'False'} />
      {autobetConfig && (
        <Stack>
          <strong>Autobet Config</strong>
          <div className={styles.AutobetConfigContainer}>
            <p className={styles.AutobetConfigLabel}>Number of Bets: </p>
            <strong className={styles.AutobetConfigValue}>{autobetConfig.numberOfBets || 0}</strong>
          </div>
          <div className={styles.AutobetConfigContainer}>
            <p className={styles.AutobetConfigLabel}>Payout on Win: </p>
            <strong className={styles.AutobetConfigValue}>{autobetConfig.payoutOnWin || 0}</strong>
          </div>
          <div className={styles.AutobetConfigContainer}>
            <p className={styles.AutobetConfigLabel}>Increase on Win: </p>
            <strong className={styles.AutobetConfigValue}>
              {autobetConfig.increaseOnWin || 0}
            </strong>
          </div>
          <div className={styles.AutobetConfigContainer}>
            <p className={styles.AutobetConfigLabel}>Increase on Loss: </p>
            <strong className={styles.AutobetConfigValue}>
              {autobetConfig.increaseOnLoss || 0}
            </strong>
          </div>
          <div className={styles.AutobetConfigContainer}>
            <p className={styles.AutobetConfigLabel}>Stop on Profit: </p>
            <strong className={styles.AutobetConfigValue}>{autobetConfig.stopOnProfit || 0}</strong>
          </div>
          <div className={styles.AutobetConfigContainer}>
            <p className={styles.AutobetConfigLabel}>Stop on Loss: </p>
            <strong className={styles.AutobetConfigValue}>{autobetConfig.stopOnLoss || 0}</strong>
          </div>
        </Stack>
      )}
      {revealedTiles && (
        <Stack>
          <strong>Revealed Tiles</strong>
          {revealedTiles.map((tile, index) => (
            <Stack direction="row" gap={1}>
              <p className={styles.RevealedTilesNumber}>
                {index + 1} - Tile Number: <strong>{tile.tileNumber || 0}</strong>
              </p>
              <p className={styles.RevealedTilesMultiplier}>
                Multiplier: <strong>{tile.multiplier || 0}</strong>
              </p>
              <p className={styles.RevealedTilesMine}>
                Mine:{' '}
                <strong className={styles.RevealedTilesMineValue}>
                  {tile.mine ? 'True' : 'False'}
                </strong>
              </p>
            </Stack>
          ))}
        </Stack>
      )}
    </Stack>
  );
};
